window.toggleMembership = function (e) {
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: { 43303927578671: e.target.checked ? 1 : 0 },
    }),
  }).catch(console.error);
};
